document.addEventListener("DOMContentLoaded", () => {
  const toggleButton = document.getElementById('theme-toggle');
  
  // Check stored theme in local storage
  const savedTheme = localStorage.getItem('theme');
  
  // Apply saved theme or default based on system preference
  if (savedTheme) {
    document.body.setAttribute('data-theme', savedTheme);
  } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    document.body.setAttribute('data-theme', 'Dark Mode');
  } else {
    document.body.setAttribute('data-theme', 'Light Mode');
  }
  
  // Toggle theme and save the preference to local storage
  toggleButton.addEventListener('click', () => {
    const currentTheme = document.body.getAttribute('data-theme');
    const newTheme = currentTheme === 'Dark Mode' ? 'Light Mode' : 'Dark Mode';
    
    document.body.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme', newTheme);
  });
});